import AddService from "../../../Components/Pricings/Services/AddService";




export default function CreateService(){
    return(
        <AddService/>
    )
}